export default "__VITE_ASSET__BHjKuPW0__"